import React, { useEffect, useRef, useState } from "react";
import { Select, Typography, Checkbox, Segmented } from "antd";
import { ConceptTypeVolume } from "../../../constants";

const { Paragraph } = Typography;

export const WidgetsConceptsFilterContent = ({
    metadata,
    // For Concepts
    onConceptsChange,
    deselect = false,
    onConceptsDeselection,
    // For Concepts List
    sentimentDisabled,
    setConceptList,
    conceptTypeDay,
    handleChangeType,
    setSelectedLocalConcepts,
    resetType
    
}) => {

    // For Concepts
    const prevSelectedConceptsRef = useRef([]);
    const conceptsOptions =
        metadata?.concepts?.options?.map(({ name }) => ({
            value: name,
            label: name,
        })) || [];

    useEffect(() => {
        prevSelectedConceptsRef.current = metadata?.concepts?.selected;
    }, [metadata?.concepts?.selected]);

    const handleChangeConcepts = (newSelectedConcepts) => {
        const previousSelectedConcepts = prevSelectedConceptsRef.current || [];
        if (deselect) {
            const deselectedConcepts = previousSelectedConcepts.filter(
                (concept) => !newSelectedConcepts.includes(concept)
            );
            onConceptsDeselection(deselectedConcepts);
        }
        onConceptsChange(newSelectedConcepts);
    };

    // For Concept Lists
    const [selectedValue, setSelectedValue] = useState(
        metadata?.conceptList?.selected
            ? metadata?.conceptList?.selected
            : `Type: ${conceptTypeDay}`
    );

    useEffect(() => {
        if (metadata?.conceptList?.selected) {
            setSelectedValue(metadata?.conceptList?.selected);
        } else if (conceptTypeDay) {
            setSelectedValue(`Type: ${conceptTypeDay}`);
        }
    }, [metadata?.conceptList?.selected, conceptTypeDay]);

    let conceptTypeOptions = Object.values(ConceptTypeVolume).map((type) => ({
        label: type.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()),
        value: `Type: ${type}`,
    }));

    const conceptListOptions = metadata?.conceptList?.options?.map((list) => ({
        label: list.name + ` (${list.concepts.length})`,
        value: list.concept_list_id,
    }));

    if (sentimentDisabled) {
        conceptTypeOptions = conceptTypeOptions.filter(
            (option) => option.value !== "Type: sentiment_suggested"
        );
    }
    
    const handleChangeConceptLists = (value) => {
        let isTypeOption = false;
        if (!Array.isArray(value)) {
            isTypeOption = value.startsWith("Type: ");
        }

        if (isTypeOption) {
            const typeValue = value.replace("Type: ", "");
            handleChangeType(typeValue);
            // setConceptList(null);
            setSelectedValue(`Type: ${typeValue}`);
        } else {
            setConceptList(value);
            setSelectedLocalConcepts([]);
            setSelectedValue(value);
            if (resetType) resetType(null);
        }
    };

    return (
        <div>
            <div className="filters-val">
                <Paragraph style={{ marginBottom: "4px", color: "#090A09" }}>
                    Lists
                </Paragraph>
                <Select
                    value={selectedValue}
                    style={{ width: "100%" }}
                    rootClassName="custom-select"
                    maxTagCount={0}
                    options={[
                        {
                            label: <span>Lists</span>,
                            options: conceptListOptions,
                        },
                        {
                            label: <span>Concept Types</span>,
                            options: conceptTypeOptions,
                        },
                    ]}
                    onChange={handleChangeConceptLists}
                ></Select>
            </div>
            <div className="filters-val">
            <p style={{ marginBottom: "4px", color: "#090A09" }}>
                Select Concepts
            </p>
            <Select
                value={metadata?.concepts?.selected}
                mode="multiple"
                maxTagCount={0}
                style={{ width: "100%" }}
                className="custom-select"
                onChange={handleChangeConcepts}
                dropdownRender={(menu) => (
                    <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                        {conceptsOptions.map((option) => (
                            <div key={option.value} style={{ padding: "4px 12px" }}>
                                <Checkbox
                                    checked={metadata?.concepts?.selected?.includes(option.value)}
                                    onChange={() =>
                                        handleChangeConcepts(
                                            metadata?.concepts?.selected?.includes(option.value)
                                                ? metadata?.concepts?.selected.filter(
                                                      (val) => val !== option.value
                                                  )
                                                : [...(metadata?.concepts?.selected || []), option.value]
                                        )
                                    }
                                >
                                    {option.label}
                                </Checkbox>
                            </div>
                        ))}
                    </div>
                )}
            />
        </div>
        </div>
    );
};
